import React from 'react'
import '../styles/MemberDetails.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SideBar from '../components/SideBar';
import '../styles/WalletPage.css';
import cash from'../assets/images/tc-cash-wallet 1.png';
import units from'../assets/images/tc-units-wallet 2.png';


function SupplierWallet() {
    const location = useLocation();
    const supplier = location.state?.supplier;
    const navigate = useNavigate();

    const goToWallet = () => {
      navigate('/supplier-wallet-details', {state: {supplier}})
    }

    const goToSupplierDetails = () => {
        navigate('/supplier-details', {state: {supplier}})
    }

    // const goToUnitsTransaction = () => {
    //     navigate('/customer-units-transaction-history', {state: {customer}})
    // }

    console.log("Received supplier:", supplier);

  return (
    <div className="member-details-layout">
      <SideBar />

        <div className="member-details-main">

            {/* Header */}
            <div className="details-header">
                <h2>Supplier Details</h2>
                <p>You can edit your details to update your profile</p>
            </div>

            {/* Breadcrumb */}
            <div className="breadcrumb">
                <Link to="/dashboard" className="breadcrumb-link">Home</Link>
                <span className="breadcrumb-separator">{">"}</span>
                <Link to="/manage-supplier" className="breadcrumb-link">Manage Supplier</Link>
                <span className="breadcrumb-separator">{">"}</span>
                <span className="breadcrumb-current">Supplier Details</span>
            </div>

            {/* buttons */}
            <div className="top-bar">
            {/* tap buttons */}
                <div className="top-buttons">
                    <button className="tab-btn" onClick={goToSupplierDetails}>Personal Details</button>
                    <button className="tab-btn active" onClick={goToWallet}>Wallet Details</button>
                </div>
            </div>

            {/* Wallet Section */}
            <div className="wallet-section">
                <div className="wallet-card">
                    <h3>TCUK TopCoin Wallet</h3>
                    <img src={units} alt="Units Wallet" className="wallet-img" />
                    <p className="balance-label">Available Balance</p>
                    <h2 className="balance-value">{supplier?.value || "0 units"}</h2>
                </div>

                <div className="wallet-card">
                    <h3>TCUK Cash Wallet</h3>
                    <img src={cash} alt="Cash Wallet" className="wallet-img" />
                    <h2 className="balance-value">N/A</h2>
                </div>
            </div>
        </div>       
    </div>
  )
}

export default SupplierWallet